module.exports = __webpack_public_path__ + "img/file-dismiss.ec403bd4.svg";